/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
export const USER_PROFILE = [
    {
        userId: 'lyn-knight-auction',
        userName: 'Lyn Knight Auction',
        bannerImg: 'https://i.picsum.photos/id/1015/6000/4000.jpg?hmac=aHjb0fRa1t14DTIEBcoC12c5rAXOSwnVlaA5ujxPQ0I',
        userImg: 'https://ui-avatars.com/api/?background=0D8ABC&color=fff&name=Lyn Knight Auction',
        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut a laoreet sapien. Sed mi est, aliquet vel velit sit amet, aliquam posuere leo. Cras varius risus id diam ullamcorper volutpat.',
        summary: [
            {
                label: 'collected',
                value: 0,
            },
            {
                label: 'created',
                value: 22,
            },
            {
                label: 'offers received',
                value: 15,
            },
            {
                label: 'offers made',
                value: 0,
            }
        ]
    },
    {
        userId: 'vlinder-labs',
        userName: 'Vlinder Labs Pvt. Ltd.',
        bannerImg: 'https://i.ibb.co/VD37gRv/blockchain.jpg',
        userImg: 'https://ui-avatars.com/api/?background=0D8ABC&color=fff&name=Vlinder Labs',
        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut a laoreet sapien. Sed mi est, aliquet vel velit sit amet, aliquam posuere leo. Cras varius risus id diam ullamcorper volutpat.',
        summary: [
            {
                label: 'collected',
                value: 0,
            },
            {
                label: 'created',
                value: 22,
            },
            {
                label: 'offers received',
                value: 15,
            },
            {
                label: 'offers made',
                value: 0,
            }
        ]
    }
]